import { Card, Col } from "reactstrap";
import { Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import ProfileIntroCard from "./ProfileIntroCard";
import FollowerCard from "./FollowerCard";
import FollowingsCard from "./FollowingsCard";
import LatestPhotos from "./LatestPhotos";
import FriendsCard from "./FriendsCard";

const RightBar = () => {
  return (
    <>
      <Col xl="12" lg="4" md="6" sm="12" className="xl-100 box-col-12">
        <ProfileIntroCard />
      </Col>
      <Col xl="12" lg="4" md="6" sm="12" className="xl-100 box-col-12">
        <FollowerCard />
      </Col>
      <Col xl="12" lg="4" md="6" sm="12" className="xl-100 box-col-12">
        <FollowingsCard />
      </Col>
      <Col xl="12" lg="4" md="6" sm="12" className="xl-100 box-col-12">
        <LatestPhotos />
      </Col>
      <Col xl="12" lg="4" md="6" sm="12" className="xl-100 box-col-12">
        <FriendsCard />
      </Col>
      <Col xl="12" lg="4" md="6" sm="12" className="xl-100 box-col-12">
        <Card>
          <Image className="img-fluid rounded-3" src={dynamicImage("social-app/timeline-4.png")} alt="timeline"/>
        </Card>
      </Col>
    </>
  );
};

export default RightBar;
